/* dropdownControlCommon.tsx generated by @compiled/babel-plugin v0.38.1 */
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["children"];
import "./dropdownControlCommon.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
// Keep PlaybackSpeedControls to use static colors from the new color palette to support the hybrid
// theming in media viewer https://product-fabric.atlassian.net/browse/DSP-6067
// with the compiled react, we are leaving the static colors in tact for now.
import React from 'react';
import { components } from '@atlaskit/select';
import { DN900 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Flex } from '@atlaskit/primitives';
export var popupCustomStyles = {
  container: function container(styles) {
    return _objectSpread(_objectSpread({}, styles), {}, {
      backgroundColor: '#22272b',
      boxShadow: 'inset 0px 0px 0px 1px #bcd6f00a,0px 8px 12px #0304045c,0px 0px 1px #03040480'
    });
  },
  // added these overrides to keep the look of the current design
  // however this does not benefit from the DS a11y changes
  menuList: function menuList(styles) {
    return _objectSpread(_objectSpread({}, styles), {}, {
      padding: '4px 0px'
    });
  },
  option: function option(styles, _ref) {
    var isFocused = _ref.isFocused,
      isSelected = _ref.isSelected;
    return _objectSpread(_objectSpread({}, styles), {}, {
      color: isSelected ? '#579dff' : DN900,
      backgroundColor: isSelected ? '#082145' : isFocused ? '#a1bdd914' : '#22272b',
      ':active': {
        backgroundColor: '#a6c5e229'
      }
    });
  },
  groupHeading: function groupHeading(styles) {
    return _objectSpread(_objectSpread({}, styles), {}, {
      color: '#9fadbc'
    });
  }
};
export var popperProps = {
  strategy: 'fixed',
  modifiers: [{
    name: 'preventOverflow',
    enabled: true
  }, {
    name: 'eventListeners',
    options: {
      scroll: true,
      resize: true
    }
  }, {
    name: 'offset',
    enabled: true,
    options: {
      offset: [0, 10]
    }
  }],
  placement: 'top'
};
var selectOptionStyles = {
  root: "_1di6r5ow"
};
export var popupSelectComponents = {
  Option: function Option(props) {
    return /*#__PURE__*/React.createElement(components.Option, _extends({}, props, {
      xcss: selectOptionStyles.root
    }));
  }
};
export var createPopupSelectComponentsWithIcon = function createPopupSelectComponentsWithIcon(IconComponent) {
  return {
    Option: function Option(_ref2) {
      var children = _ref2.children,
        props = _objectWithoutProperties(_ref2, _excluded);
      var childrenWithIcon = /*#__PURE__*/React.createElement(Flex, {
        justifyContent: "space-between",
        alignItems: "center"
      }, children, /*#__PURE__*/React.createElement(IconComponent, {
        label: props.label,
        value: "".concat(props.data.value)
      }));
      return /*#__PURE__*/React.createElement(components.Option, _extends({}, props, {
        children: childrenWithIcon,
        xcss: selectOptionStyles.root
      }));
    }
  };
};